import React, { useState, useEffect } from "react";
import Card from "../HistorServicios/Card";
import styles from "./CardContainer.module.css";
import { FaInbox } from "react-icons/fa";

export default function CardContainer({ allticketced, searchTerm, estadoFilter, tecnicoFilter }) {
  const [currentPage, setCurrentPage] = useState(1);

  const cardsPerPage = 12;
  const pagesPerBlock = 5; // Reduced for better mobile/clean look

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, estadoFilter, tecnicoFilter]);

  if (!Array.isArray(allticketced) || allticketced.length === 0) {
    return (
      <div className={styles.noResults}>
        <FaInbox style={{ fontSize: '3rem', color: '#e2e8f0', marginBottom: '16px' }} />
        <p style={{ color: '#64748b', fontWeight: '600' }}>No hay registros disponibles en el sistema.</p>
      </div>
    );
  }

  /** 🔹 Normalización de tickets */
  const allTickets = allticketced.flatMap(item =>
    item.tickets
      ? item.tickets.map(ticket => ({
        ...ticket,
        nombre: item.usuario.nombre
      }))
      : []
  );

  /** 🔹 Último estado por ticket */
  const latestTickets = allTickets.reduce((acc, ticket) => {
    // Usar el ID secuencial si está disponible para asegurar el orden cronológico real,
    // previniendo problemas de desincronización de milisegundos en la fecha entre eventos.
    const hasExisting = !!acc[ticket.TicketId];
    const isNewerById = hasExisting && ticket.id && acc[ticket.TicketId].id && ticket.id > acc[ticket.TicketId].id;
    const isNewerByDate = hasExisting && new Date(ticket.fecha) > new Date(acc[ticket.TicketId].fecha);

    if (
      !hasExisting ||
      (ticket.id && acc[ticket.TicketId].id ? isNewerById : isNewerByDate)
    ) {
      acc[ticket.TicketId] = ticket;
    }
    return acc;
  }, {});

  const latestTicketsArray = Object.values(latestTickets);

  const sortedTickets = latestTicketsArray.sort(
    (a, b) => new Date(b.fecha) - new Date(a.fecha)
  );

  const getTecnicoByTicketId = (ticketId) => {
    const historial = allticketced
      ?.flatMap(item => item.tickets || [])
      .filter(t => t.TicketId === ticketId);

    const registro = historial.find(
      t => t.EstadoId === 2 && t.Usuario
    );

    return registro?.Usuario?.nombre?.trim() || "";
  };

  const filteredTickets = sortedTickets.filter(ticket => {
    const matchSearch =
      ticket.TicketId.toString().includes(searchTerm) ||
      ticket.nombre.toLowerCase().includes(searchTerm.toLowerCase());

    const matchEstado =
      estadoFilter === "ALL" || ticket.EstadoId.toString() === estadoFilter;

    const tecnico = getTecnicoByTicketId(ticket.TicketId);
    const matchTecnico =
      tecnicoFilter === "ALL" || tecnico === tecnicoFilter;

    return matchSearch && matchEstado && matchTecnico;
  });

  /** 🔹 Paginación */
  const totalPages = Math.ceil(filteredTickets.length / cardsPerPage);

  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  const currentCards = filteredTickets.slice(
    indexOfFirstCard,
    indexOfLastCard
  );

  /** 🔹 Cálculo de bloque actual */
  const currentBlock = Math.ceil(currentPage / pagesPerBlock);
  const startPage = (currentBlock - 1) * pagesPerBlock + 1;
  const endPage = Math.min(startPage + pagesPerBlock - 1, totalPages);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <div className={styles.container}>
      {/* ========== PAGINACIÓN ========== */}
      {totalPages > 1 && (
        <div className={styles.pagination}>
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Anterior
          </button>

          {startPage > 1 && (
            <button onClick={() => handlePageChange(startPage - 1)}>
              ...
            </button>
          )}

          {Array.from(
            { length: endPage - startPage + 1 },
            (_, index) => {
              const page = startPage + index;
              return (
                <button
                  key={page}
                  onClick={() => handlePageChange(page)}
                  className={currentPage === page ? styles.activePage : ""}
                >
                  {page}
                </button>
              );
            }
          )}

          {endPage < totalPages && (
            <button onClick={() => handlePageChange(endPage + 1)}>
              ...
            </button>
          )}

          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Siguiente
          </button>
        </div>
      )}

      {/* ========== CARDS ========== */}
      <div className={styles.container1}>
        {currentCards.length > 0 ? (
          currentCards.map(ticket => (
            <Card
              key={ticket.TicketId}
              ticket={ticket}
              allticketced={allticketced}
            />
          ))
        ) : (
          <div className={styles.noResults}>
            <FaInbox style={{ fontSize: '3rem', color: '#e2e8f0', marginBottom: '16px' }} />
            <p style={{ color: '#64748b', fontWeight: '600' }}>No se encontraron resultados para su búsqueda.</p>
          </div>
        )}
      </div>
    </div>
  );
}
